// extracted by mini-css-extract-plugin
export default {"investBlock":"InvestBlock_investBlock__k-bbX"};